const getCurrentPrice = require('../../product/tools/get-current-price')
const get = require('lodash/get')

const transformProducts = (products = [], warehouseByMarket = {}) => {
  // Transform the product object as needed
  return products
    .filter(product => product.additionalData.market && ['LGS', 'NBO'].includes(product.additionalData.market))
    .map(product => {
      const market = get(product, 'additionalData.market')
      const warehouseCode = get(warehouseByMarket[market], 'code')
      if (!warehouseCode) return
      return {
        ean: product.ean || '3600541234568', // TODO: remove these defaults when we actually have this data
        hsn: product.hsn || '30046000',
        code: product.code,
        price: Number(getCurrentPrice(product.prices)),
        deleted: false,
        buyPrice: Number(getCurrentPrice(product.buyPrices)),
        category: get(product, 'additionalData.category'),
        coldChain: product.coldChain || false,
        scannable: product.scannable || true,
        serialized: product.serialized || false,
        description: product.fullName,
        productType: product.productType,
        manufacturer: get(product, 'additionalData.manufacturer'),
        tracksBatches: product.tracksBatches || true,
        minimum_shelf_life: 0,
        product_shelf_life: 0,
        customer_shelf_life: 0,
        warehouseCode
      }
    })
    .filter(x => x)
}

module.exports = transformProducts
